import React from 'react';
import { Link } from 'react-router-dom';
import FloatingCards from '../components/FloatingCards';

const HomePage = () => {
    return (
        <div className="home-page">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-container">
                    <div className="hero-content">
                        <h1>Come Fly with Megh.ai</h1>
                        <p className="subtitle">
                            Unleash the full potential of Artificial Intelligence in your enterprise.
                            We design AI solutions that optimize your operations end-to-end, making
                            them more seamless, efficient, and cost-effective.
                        </p>
                        <div className="hero-buttons">
                            <Link to="/contact" className="btn-primary">Get Started</Link>
                            <Link to="/about" className="btn-secondary">Learn More</Link>
                        </div>
                    </div>
                    <div className="hero-visual">
                        <FloatingCards />
                    </div>
                </div>
            </section>

            {/* Services Section */}
            <section className="services">
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">What We Do</h2>
                        <p className="section-subtitle">
                            Comprehensive AI solutions tailored to transform your business operations
                        </p>
                    </div>
                    <div className="services-grid">
                        <div className="service-card">
                            <div className="service-icon">🤖</div>
                            <h3>AI Consulting</h3>
                            <p>
                                Strategic guidance to identify and implement the most suitable AI solutions
                                for your business needs, ensuring optimal ROI and seamless integration.
                            </p>
                        </div>
                        <div className="service-card">
                            <div className="service-icon">🏢</div>
                            <h3>Enterprise Solutions</h3>
                            <p>
                                Comprehensive enterprise applications designed to streamline operations,
                                enhance productivity, and drive digital transformation at scale.
                            </p>
                        </div>
                        <div className="service-card">
                            <div className="service-icon">⚙️</div>
                            <h3>Implementation & Support</h3>
                            <p>
                                End-to-end implementation services with ongoing support to ensure your
                                AI solutions continue to deliver value and adapt to changing needs.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Technology Preview */}
            <section className="technology">
                <div className="container">
                    <div className="tech-grid">
                        <div className="tech-content">
                            <h2>Our Innovative Technology</h2>
                            <p>
                                At Megh.ai, our comprehensive technological solutions help industry
                                leading companies achieve greater success. Our platform continuously
                                evolves to empower users with cutting-edge capabilities.
                            </p>
                            <div className="tech-features">
                                <div className="tech-feature">
                                    <div className="tech-feature-icon">🧠</div>
                                    <span>Machine Learning</span>
                                </div>
                                <div className="tech-feature">
                                    <div className="tech-feature-icon">🔄</div>
                                    <span>Process Automation</span>
                                </div>
                                <div className="tech-feature">
                                    <div className="tech-feature-icon">📊</div>
                                    <span>Data Analytics</span>
                                </div>
                                <div className="tech-feature">
                                    <div className="tech-feature-icon">🌐</div>
                                    <span>IoT Integration</span>
                                </div>
                            </div>
                        </div>
                        <div className="tech-visual">
                            <div className="tech-circles">
                                <div className="tech-circle"></div>
                                <div className="tech-circle"></div>
                                <div className="tech-circle"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomePage;